import dayjs from 'dayjs';
import { Spinner } from 'flowbite-react';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import { ASSESS_PLATFORM_FRONTEND } from 'src/config/env.config';
import { useGetContestById } from 'src/hooks/contest';

const LiveContest = () => {
	const navigate = useNavigate();
	const { contestId } = useParams();

	const { data, isLoading, isFetching } = useGetContestById({
		id: contestId || '',
		onError: err => {
			console.log('data:', err);
		},
	});

	useEffect(() => {
		window.addEventListener('message', e => {
			const data = e.data;
			console.log('data:', data);
			if (data.type === 'assessment-ended' || data.type === 'assessment-forcefully-ended') {
				navigate('/');
			}
		});
	}, []);

	useEffect(() => {
		if (!isLoading && !isFetching && !data) {
			navigate('/contests');
		}

		if (
			!isLoading &&
			!isFetching &&
			((data && dayjs().isAfter(data?.contest?.endDate)) || (data && !data?.contest?.userAttempt?.contestToken))
		) {
			navigate('/contests');
		}
	}, [isLoading, isFetching, data]);

	if (isLoading || isFetching) {
		return (
			<div className="flex justify-center h-full min-h-screen">
				{/* <Spinner /> */}
				<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
			</div>
		);
	}

	return (
		<iframe
			title="contest"
			className="h-[100dvh] w-full"
			src={
				data?.contest?.userAttempt?.contestToken
					? `${ASSESS_PLATFORM_FRONTEND}/test?token=${data?.contest?.userAttempt?.contestToken}`
					: `${data?.contest?.userAttempt?.contestToken}`
			}
			allow="camera; microphone; display-capture; window-management;"
		></iframe>
	);
};

export default LiveContest;
